<script setup lang="ts">
import type { SelectOptions } from '@autobid/ui/types/components/Select'
import type { FormKitFrameworkContext } from '@formkit/core'
import Select from './Select.vue'

interface Props {
  context: FormKitFrameworkContext & {
    placeholder?: string
    multiple?: boolean
    disableSearch?: boolean
    options: SelectOptions
  }
}

const props = defineProps<Props>()

function handleChange(value: SelectOptions | undefined) {
  props.context.node.input(value)
  props.context.node.context?.handlers.blur()
}
</script>

<template>
  <Select
    :value="context.value"
    :placeholder="context.placeholder"
    :input-id="context.id"
    :options="context.options"
    :multiple="context.multiple"
    :disable-search="context.disableSearch"
    :required="context.state.required"
    @change="handleChange"
  />
</template>
